import { useEffect, useState } from 'react';
import { fetchLivePeriod, type LivePeriodSnapshot } from '../../lib/sepoliaLive';

export default function LivePeriod() {
  const [data, setData] = useState<LivePeriodSnapshot | null | undefined>(undefined);

  useEffect(() => {
    let cancelled = false;
    fetchLivePeriod()
      .then((d) => { if (!cancelled) setData(d); })
      .catch(() => { if (!cancelled) setData(null); });
    return () => { cancelled = true; };
  }, []);

  if (data === undefined) return <Box>Loading current period…</Box>;
  if (data === null)      return <Box>Live data unavailable. Set <code>VITE_SEPOLIA_RPC</code> in <code>.env.local</code>.</Box>;

  return (
    <Box>
      <div className="lp-row"><span>Current period</span><strong>{data.currentPeriod.toLocaleString()}</strong></div>
      <div className="lp-row"><span>Raised this period</span><strong>{data.thisPeriodRaisedEth.toFixed(4)} ETH</strong></div>
      <div className="lp-row"><span>Remaining</span><strong>{data.remainingSecs}s</strong></div>
      <div className="lp-row"><span>Total raised</span><strong>{data.totalRaisedEth.toFixed(4)} ETH</strong></div>
      <style>{css}</style>
    </Box>
  );
}

function Box({ children }: { children: React.ReactNode }) {
  return <div className="lp-box">{children}</div>;
}

const css = `
.lp-box {
  background: var(--c-bg-alt);
  border: 1px solid var(--c-border);
  border-radius: var(--radius);
  padding: 16px;
  margin: 16px 0;
  font-size: 0.92rem;
}
.lp-row { display: flex; justify-content: space-between; padding: 4px 0; }
.lp-row + .lp-row { border-top: 1px dashed var(--c-border); }
.lp-row strong { font-variant-numeric: tabular-nums; }
`;
